// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loading[data-v-6f3dc06d]{min-height:320px}@media(min-width:640px){.loading[data-v-6f3dc06d]{min-height:460px}}p[data-v-6f3dc06d]{color:var(--base-medium-color);font-size:.7rem;margin-top:1rem;display:block;clear:both;text-align:center;margin-bottom:2rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
